import LogRocket from 'logrocket';
/**
 * Reports an error to LogRocket if available. See https://docs.logrocket.com/docs/error-reporting
 * If not, reports the error to the console
 * @param {*} error - The error to report. Should be an exception object.
 * @param {*} context - The context of the error. Should be an string describing where the error took place.
 * @param {*} additionalOptions may include tags or extra objects to be included with the error
 */
export const reportException = (error, context, additionalOptions = {}) => {
  if (process.env.REACT_APP_LOGROCKET_APP_ID) {
    LogRocket.captureException(error, {
      tags: { context, ...additionalOptions?.tags },
      extra: additionalOptions?.extra,
    });
  } else {
    console.error(error);
  }
};

/**
 * Reports an error to LogRocket if available. See https://docs.logrocket.com/docs/error-reporting
 * If not, reports the error to the console
 * @param {*} error - The error to report. Should be a string.
 * @param {*} context - The context of the error. Should be an string describing where the error took place.
 * @param {*} additionalOptions may include tags or extra objects to be included with the error
 */
export const reportError = (error, context, additionalOptions = {}) => {
  if (process.env.REACT_APP_LOGROCKET_APP_ID) {
    LogRocket.captureMessage(error, {
      tags: { context, ...additionalOptions?.tags },
      extra: additionalOptions?.extra,
    });
  } else {
    console.error(error);
  }
};
